/**
 * useSubContratos
 *
 */
import React from 'react'
import Api from '../../../Api'
import Exception from '../../../Exception'

/**
 *
 * @param {string} search
 * @returns
 */
function queryRecords(search) {
  const likeSearch = { $like: `%${search}%`}
  const filter = (!search) || (search.length === 0) ? null : {
    $or: [
      { sContrato: likeSearch },
      { sNombreCorto: likeSearch },
      { mDescripcionCorta: likeSearch },
    ]
  }

  return Api.query({
    model: 'CmrProject',
    attributes: [
      'iId',
      'sAlias',
      'sContrato',
      'sNombreCorto',
      'sCodigo',
      'dMonto',
    ],

    include: [{
      as: 'ordenServicio',
      required: true,
      attributes: [
        ['sConsecutivo', 'folio']
      ],
      where: {
        iId_proveedor: Api.getProviderId(),
      }
    }],

    where: {
      iActivo: true,
      iSubContrato: true,
      lStatus: 'ACTIVO',
      ...filter
    },
    order: [
      ['iId', 'DESC']
    ]
  })
}

/**
 *
 */
export function useSubContratos() {
  const [loading, setLoading] = React.useState(false)
  const [records, setRecords] = React.useState([])

  const fetch = (search) => {
    queryRecords(search)
      .then(res => {
        setLoading(false)
        setRecords(res.data)
      })
      .catch(err => {
        setLoading(false)
        Exception.load(err).show()
      })
  }

  return {
    loading,
    records,
    fetch,
  }
}
